import { constants } from "../../../constants";

export default class GameRoundEnd {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.gameRoundEnd();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.YGG:
                event["gameRound/end"] = this._default;
                break;
            case constants.HBN:
                event["gameRoundEnded"] = this._default;
                break;
            default:
                event["gameRoundEnd"] = this._default;
        }

        return event;
    }
}
